import { toDisplayCurrency } from '../../../utils';
import { StyledAmount } from './styled';

export interface AmountProps {
  amount: number;
  signed?: boolean;
}

/**
 * @deprecated Use the Amount component in the @payflip/ui/v2 instead
 */

export function Amount({ amount, signed = true }: AmountProps): JSX.Element {
  return (
    <StyledAmount positive={amount > 0 && signed}>
      {toDisplayCurrency(amount, 'EUR', signed)}
    </StyledAmount>
  );
}
